var map = {
	"./afb-color.svg": 646,
	"./alb-color.svg": 647,
	"./all.svg": 648,
	"./amb-color.svg": 649,
	"./arg.svg": 650,
	"./aus.svg": 651,
	"./bank-icon.svg": 652,
	"./bankdemo-color.svg": 653,
	"./bel.svg": 654,
	"./bimb-color.svg": 655,
	"./bkr-color.svg": 656,
	"./bpay-color.svg": 657,
	"./bra.svg": 658,
	"./bsn-color.svg": 659,
	"./can.svg": 660,
	"./checked-green.png": 661,
	"./checked-white.png": 662,
	"./cimb-color.svg": 663,
	"./cimb-icon.svg": 664,
	"./citi-color.svg": 665,
	"./cmr.svg": 666,
	"./crc.svg": 667,
	"./cro.svg": 668,
	"./den.svg": 669,
	"./ecu.svg": 670,
	"./eng.svg": 671,
	"./esp.svg": 672,
	"./fav-blue.svg": 673,
	"./fav-gray.png": 674,
	"./fav-gray.svg": 675,
	"./fav-icon-active.png": 676,
	"./fav-icon.png": 677,
	"./fav-red.png": 678,
	"./fra.svg": 679,
	"./game-icon.svg": 680,
	"./games-active-m.svg": 681,
	"./ger.svg": 682,
	"./gha.svg": 683,
	"./gxbank-color.svg": 684,
	"./hlb-color.svg": 685,
	"./hlb-icon.svg": 686,
	"./hsbc-color.svg": 687,
	"./irn.svg": 688,
	"./jpn.svg": 689,
	"./kor.svg": 690,
	"./ksa.svg": 691,
	"./kwh-color.svg": 692,
	"./latest-icon-active.png": 693,
	"./latest-icon.png": 694,
	"./lc-active-m.svg": 695,
	"./lc-icon.svg": 696,
	"./lottery-active-m.svg": 697,
	"./lottery-icon.svg": 698,
	"./lottery-m.svg": 699,
	"./love.svg": 700,
	"./mar.svg": 701,
	"./mbb-color.svg": 702,
	"./mex.svg": 703,
	"./ned.svg": 704,
	"./ocbc-color.svg": 705,
	"./ocbc-icon.svg": 706,
	"./p2p-active-m.svg": 707,
	"./p2p-icon.svg": 708,
	"./p2p-m.svg": 709,
	"./pbb-color.svg": 710,
	"./pol.svg": 711,
	"./por.svg": 712,
	"./price-high.svg": 713,
	"./price-low.svg": 714,
	"./qat.svg": 715,
	"./rhb-color.svg": 716,
	"./rhb-icon.svg": 717,
	"./scb-color.svg": 718,
	"./sen.svg": 719,
	"./slot-active-m.svg": 720,
	"./slot-icon.svg": 721,
	"./sport-active-m.svg": 722,
	"./sports-icon.svg": 723,
	"./srb.svg": 724,
	"./star.svg": 725,
	"./sui.svg": 726,
	"./tng-color.svg": 727,
	"./trx-icon.svg": 728,
	"./trx.svg": 729,
	"./tun.svg": 730,
	"./uob-color.svg": 731,
	"./uru.svg": 732,
	"./usa.svg": 733,
	"./usdc.svg": 734,
	"./usdt.svg": 735,
	"./ustd-icon.svg": 736,
	"./wal.svg": 737,
	"./x33-logo-b.svg": 738,
	"./x33-square-icon.svg": 739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;